export default {
  tablist: {
    background: 'transparent',
  },
};
